var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturedIconChoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFC72C",
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 12.6663V12.533C21.3333 11.4129 21.3333 10.8529 21.1153 10.425C20.9236 10.0487 20.6176 9.74274 20.2413 9.55099C19.8134 9.33301 19.2534 9.33301 18.1333 9.33301H13.8666C12.7465 9.33301 12.1865 9.33301 11.7586 9.55099C11.3823 9.74274 11.0764 10.0487 10.8846 10.425C10.6666 10.8529 10.6666 11.4129 10.6666 12.533V19.4663C10.6666 20.5864 10.6666 21.1465 10.8846 21.5743C11.0764 21.9506 11.3823 22.2566 11.7586 22.4484C12.1865 22.6663 12.7465 22.6663 13.8666 22.6663H16.3333M16.3333 15.333H13.3333M15.6666 17.9997H13.3333M18.6666 12.6663H13.3333M20 19.9997V16.333C20 15.7807 20.4477 15.333 21 15.333C21.5522 15.333 22 15.7807 22 16.333V19.9997C22 21.1042 21.1045 21.9997 20 21.9997C18.8954 21.9997 18 21.1042 18 19.9997V17.333",
    stroke: "#535862",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedIconChoice);
export default __webpack_public_path__ + "static/media/featured-icon-choice.d7aa3b00e4572f8c1e7bdf7fa659204f.svg";
export { ForwardRef as ReactComponent };